import LoginPage from "../../components/templates/login/LoginPage"

//login page
const Login = () => {
  return (<LoginPage/>)
}

export default Login;